<app-filter-region [filters]="filter" [programCtrl]="programCtrl"></app-filter-region>
<app-table-region [filters]="filter" [programCtrl]="programCtrl" ></app-table-region>
